import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import PartialPaymentServices from "services/PartialPaymentServices";
import { notifyError, notifySuccess } from "utils/toast";

const usePartialPayment = (id) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading,setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setIsSubmitting(true);
   
   
      const PartialPaymentData = {
      
        less_than:data.less_than_24,
        more_than:data.more_than_24,
     
    
      };

   
      
         const  res = await PartialPaymentServices.updatePartialPayment(PartialPaymentData);
     
    
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
    
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };
  const getPartialPaymentData = async () => {

    try {
    
   
       const  res = await PartialPaymentServices.getAllPartialPayment();

      if (res) {
     

        setValue("more_than_24", res.data.more_than_24);
        setValue("less_than_24", res.data.less_than_24);
      
       
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("more_than_24");
      setValue("less_than_24");
   
      clearErrors();
      return;
    }
      
    if (id) {
      getPartialPaymentData();
    }
    // eslint-disable-next-line
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,loading,setLoading,
    errors,
    isSubmitting,
   
  
  };
};  

export default usePartialPayment;
